import { jsx as _jsx } from "react/jsx-runtime";
import { TextS } from 'frontend/js/modules/infra/dls/components/typography';
import styles from './styles.module.scss';
import { isActiveRecurringCampaign, isCompleted, isDraft, isPausedRecurringCampaign, isScheduled, isSending, } from '../../../../campaign-utils';
import { Logger } from '../../../../../../infra/observability/logger';
import { getViewerIdAndKind, useSession } from '../../../../../../infra/session';
import { Pill } from '../../../../components/pill/pill';
import { t } from '../../../../../../infra/i18n';
export var buildStatusProps = function (campaign) {
    var id = campaign.id, status = campaign.status, type = campaign.type;
    if (isDraft(campaign)) {
        return {
            status: t('engage:status.draft'),
            pillVariant: 'primary',
            textColor: 'primary',
            campaignId: id,
        };
    }
    if (isPausedRecurringCampaign(campaign)) {
        return {
            status: t('engage:status.paused'),
            pillVariant: 'red',
            textColor: 'negative',
            campaignId: id,
        };
    }
    if (isCompleted(campaign)) {
        return {
            status: t('engage:status.sent'),
            pillVariant: 'green',
            textColor: 'positive',
            campaignId: id,
        };
    }
    if (isScheduled(campaign) || isActiveRecurringCampaign(campaign)) {
        return {
            status: t('engage:status.scheduled'),
            pillVariant: 'brand',
            textColor: 'brand',
            campaignId: id,
        };
    }
    if (isSending(campaign)) {
        return {
            status: t('engage:status.sending'),
            pillVariant: 'brand',
            textColor: 'brand',
            campaignId: id,
        };
    }
    // This is a fallback that should not happen in theory?
    Logger.warn("Unprocessed campaign status: ".concat(status, ", type: ").concat(type, ", id: ").concat(id));
    return {
        status: t('engage:status.scheduled'),
        pillVariant: 'brand',
        textColor: 'brand',
        campaignId: id,
    };
};
export var Status = function (_a) {
    var status = _a.status, pillVariant = _a.pillVariant, textColor = _a.textColor, campaignId = _a.campaignId;
    var session = useSession().data;
    var kind = getViewerIdAndKind(session).kind;
    return (_jsx("div", { className: kind === 'shop' ? styles['status-container-shop'] : styles['status-container'], children: _jsx(Pill, { variant: pillVariant, automationId: "text:campaignStatus:".concat(campaignId), children: _jsx(TextS, { color: textColor, "data-automation-id": "text:campaignStatus:".concat(campaignId), children: status }) }) }));
};
